export function checkPermissions({
  permissions,
  scopes,
  gates,
  crmObject,
  nonCrmObject
}) {
  if (!permissions) {
    return true;
  }
  const hasScopes = permissions.scopes ? permissions.scopes.every(scope => scopes.includes(scope)) : true;
  const hasGates = permissions.gates ? permissions.gates.every(gate => gates.includes(gate)) : true;
  const passesCustomValidation = permissions.custom ? permissions.custom({
    scopes,
    gates,
    crmObject,
    nonCrmObject
  }) : true;
  return hasScopes && hasGates && passesCustomValidation;
}